import { Form, Formik } from 'formik';
import { getErrorMessage } from 'loopback-error-parser';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card } from 'lib/releox-react';
import AcceptedOfferReportTable2 from '../../components/AcceptedOfferReportTable2';
import ReportForm2 from '../../forms/report/ReportForm2';
import {
  acceptedOffersReportRequest,
  AcceptedOffersReportResponse,
} from '../../requests/report.request';
import MaterialsAction from '../../store/material/MaterialsAction';
import MaterialsSelector from '../../store/material/MaterialsSelector';
import RednotAction from '../../store/rednot/RednotAction';

export default () => {
  const [isLoading, setIsLoading] = useState(false);
  const materials = useSelector(MaterialsSelector.selectMaterials);
  const dispatch = useDispatch();
  const [data, setData] = useState<AcceptedOffersReportResponse | null>(null);

  const initValues = useMemo(
    () => ({
      start: moment()
        .subtract(1, 'week')
        .startOf('day')
        .toDate(),
      end: moment()
        .endOf('day')
        .toDate(),
      team: '',
    }),
    []
  );

  useEffect(() => {
    dispatch(MaterialsAction.list());
  }, [dispatch]);

  const onSubmit = useCallback(
    async (body) => {
      try {
        setIsLoading(true);
        const localData = await acceptedOffersReportRequest(body);
        setData(localData);
        setIsLoading(false);
      } catch (e) {
        dispatch(RednotAction.error(getErrorMessage(e)));
      }
    },
    [dispatch]
  );

  return (
    <div id="ReportIndexScene">
      <div>
        <Card>
          <Formik onSubmit={onSubmit} initialValues={initValues}>
            <Form>
              <div className="row">
                <ReportForm2 />
                <div className="col-md-2">
                  <Button
                    id="submit"
                    type="submit"
                    className="btn-block mt-4"
                    disabled={isLoading}
                    disabledText="Loading..."
                  >
                    Search
                  </Button>
                </div>
              </div>
            </Form>
          </Formik>
        </Card>
      </div>
      {data ? <AcceptedOfferReportTable2 data={data} materials={materials} /> : null}
    </div>
  );
};
